<template>
  <main class="login">
    <section>
      <div class="branding">
        <figure class="logo" alt="PTC Wizard Logo">
          <Logo />
        </figure>
        <div class="school-name">{{ schoolStore?.school?.school_name }}</div>
      </div>
      <div class="card">
        <form
          class="needs-validation"
          :class="[wasValidated ? 'was-validated' : null]"
          @click.prevent="save"
        >
          <h4 class="card-header">Reset Password</h4>
          <div class="card-body">
            <p class="text-start">
              Please choose a new password for your PTC Wizard account. If you did not request to
              change your password, then please contact your school administrator immediately.
            </p>
            <div class="vstack gap-2 mb-4" v-if="!passwordReset">
              <div class="form-floating input-group input-group-end">
                <input
                  :type="[cleartextPass1 ? 'text' : 'password']"
                  class="form-control form-control-lg"
                  id="password2"
                  placeholder="Choose New Password"
                  @click="clearForm()"
                  required
                  v-model="password"
                />
                <label for="password2">Choose New Password</label>
                <button
                  class="btn btn-lg"
                  @click="cleartextPass1 = !cleartextPass1"
                  :title="[cleartextPass1 ? 'Hide Password' : 'Show Password']"
                >
                  <i
                    class="bi text-primary"
                    :class="[cleartextPass1 ? 'bi-eye-slash-fill' : 'bi-eye-fill']"
                  ></i>
                </button>
                <div class="invalid-tooltip">Validation Error Message</div>
              </div>

              <div class="form-floating input-group input-group-end">
                <input
                  :type="[cleartextPass2 ? 'text' : 'password']"
                  class="form-control form-control-lg"
                  id="password2"
                  placeholder="Confirm New Password"
                  @focusin="clearForm()"
                  required
                  v-model="password_confirm"
                />
                <label for="password2">Confirm New Password</label>
                <button
                  class="btn btn-lg"
                  @click="cleartextPass2 = !cleartextPass2"
                  :title="[cleartextPass2 ? 'Hide Password' : 'Show Password']"
                >
                  <i
                    class="bi text-primary"
                    :class="[cleartextPass2 ? 'bi-eye-slash-fill' : 'bi-eye-fill']"
                  ></i>
                </button>
                <div class="invalid-tooltip">Validation Error Message</div>
              </div>
            </div>

            <button
              class="submit"
              @click="loadingState = !loadingState"
              :disabled="loadingState"
              v-if="!passwordReset"
            >
              <span>Change password</span>
            </button>
            <div class="alert alert-danger px-5 mt-2" v-if="passwordError">
              {{ errorMsg }}
            </div>
            <div class="alert alert-success px-5 mt-2" v-if="passwordReset">
              Your new password has been saved.<br />
              <router-link
                :to="{
                  name: 'teacher-login',
                  params: { account: $route.params.account }
                }"
                >Sign in with new password</router-link
              >
            </div>
          </div>
          <div class="card-footer">
            <router-link
              class="btn btn-link"
              :to="{
                name: 'teacher-login',
                params: { account: $route.params.account }
              }"
            >
              <i class="bi bi-arrow-left me-2 opacity-50"></i><span>Return to Sign In</span>
            </router-link>
          </div>
        </form>
      </div>
      <small class="text-muted vstack gap-1">
        <strong class="opacity-50">Parent Teacher Conference Scheduling Made Easy</strong>
        <div>&copy;2006 - {{ new Date().getFullYear() }} PTC Wizard, All rights reserved.</div>
      </small>
    </section>
  </main>
</template>

<script setup>
import { ref, onMounted } from "vue";
import AuthService from "@/services/auth.service";
import { useSchoolStore } from "@/stores/school";

import Logo from "@/assets/icons/logo-vertical-regular.svg";
import { useRoute } from "vue-router";
const loadingState = ref(false);
const wasValidated = ref(false);
const cleartextPass1 = ref(false);
const cleartextPass2 = ref(false);
const password = ref(null);
const password_confirm = ref(null);
const route = useRoute();
const passwordReset = ref(false);
const passwordError = ref(false);
const schoolStore = useSchoolStore();
const school = ref({});
const errorMsg = ref("");
function clearForm() {
  wasValidated.value = false;
  loadingState.value = false;
  return true;
}

function save() {
  if (password.value != password_confirm.value || password.value == null || password.value == "") {
    wasValidated.value = true;
    loadingState.value = false;

    return false;
  }
  loadingState.value = true;
  var user = {
    password: password.value,
    uid: route.params.uid,
    account: route.params.account,
    authentication_type: "teacher"
  };
  AuthService.resetPassword(user).then((response) => {
    loadingState.value = false;
    if (response.status) {
      passwordReset.value = true;
      passwordError.value = false;
    } else if (response.error) {
      // console.log(response);
      if (schoolStore.school.school_email != null) {
        errorMsg.value =
          "Password can not be reset for this user account at this time.  Please request a passsword reset again or contact your school for help at " +
          schoolStore.school.school_email;
      } else {
        errorMsg.value =
          "Password can not be reset for this user account at this time.  Please request a passsword reset again or contact your school for help";
      }

      passwordReset.value = false;
      passwordError.value = true;
    }
  });
}
onMounted(() => {
  console.log("test");
  if (school.value.school_id) {
    return true;
  } else {
    if (route.params.account != null && route.params.account != "") {
      schoolStore.fetchSchool(route.params.account).then(() => {
        school.value = schoolStore.school;
        console.log("School found");
      });
    } else {
      window.location.href = "https://www.ptcwizard.com";
    }
  }
});
</script>
